import { Component, EventEmitter, Output, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { DataserviceService } from 'src/app/dataservice.service';
import { formatDate } from '@angular/common';
import { NzMessageService } from 'ng-zorro-antd/message';


export function adultValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) return null; 
  
  const dob = new Date(control.value);
  const today = new Date();

  let age = today.getFullYear() - dob.getFullYear();
  const monthDiff = today.getMonth() - dob.getMonth();

  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
    age--;
  }

  return age < 18 ? { notAdult: true } : null;
}

const disallowSelfPhone = (own: string) => {
  const norm = (v: string) => {
    const d = (v || '').replace(/\D/g, '');
    return d.length === 11 && d.startsWith('1') ? d.slice(1) : d;
  };
  const ownNorm = norm(own);
  return (c: AbstractControl): ValidationErrors | null =>
    norm(c.value) === ownNorm ? { selfPhone: true } : null;
};

@Component({
  selector: 'app-general-info',
  templateUrl: './general-info.component.html',
  styleUrl: './general-info.component.css'
})
export class GeneralInfoComponent {
  @Output() next = new EventEmitter<void>();
  @Output() customerCreated = new EventEmitter<{ customerInfo: any; customerId: string, scrubAddressResponse: any, authenticateCustomerResponse: any, conversationId: any }>();
  @Input() fullData: any;

  currentUser: any;
  customerId: any;

  infoForm: FormGroup;
  loadingId: any;
  btnLoading: boolean = false;
  states: any;
  private readonly formDefaults = {
    firstName: '',
    lastName: '',
    address: '',
    phone: '',
    secondPhone: '',
    permissionToCall: false,
    dob: '',
    city: '',
    state: '',
    zip: '',
  };

  constructor(
    private fb: FormBuilder,
    private data: DataserviceService,
    private message: NzMessageService
  ) {

    this.infoForm = this.fb.group({
      firstName: [this.formDefaults.firstName, Validators.required],
      lastName: [this.formDefaults.lastName, Validators.required],
      address: [this.formDefaults.address, Validators.required],
      phone: [this.formDefaults.phone, Validators.required],
      secondPhone: [this.formDefaults.secondPhone],
      permissionToCall: [this.formDefaults.permissionToCall, Validators.requiredTrue],
      dob: ['', [Validators.required, adultValidator]],
      city: [this.formDefaults.city, Validators.required],
      state: [this.formDefaults.state, Validators.required],
      zip: [this.formDefaults.zip, Validators.required],
    });

    this.states = this.data.states;

    this.currentUser = JSON.parse(localStorage.getItem('user') || '{}');
  }

  ngOnInit() {
    console.log(this.currentUser)
    this.tryPrefillFromInput();
    this.applyPhoneValidator();
  }

  tryPrefillFromInput() {
    if (this.fullData?.customerInfo) {
      this.initializeForm(this.fullData?.customerInfo);
    } else {
      this.resetFormToDefaults();
    }
  }

  resetFormToDefaults() {
    this.infoForm.reset(this.formDefaults);
  }

  initializeForm(src: any) {

    this.infoForm.patchValue({
      firstName: src.firstName ?? this.formDefaults.firstName,
      lastName: src.lastName ?? this.formDefaults.lastName,
      address: src.address ?? this.formDefaults.address,
      phone: src.phone ?? this.formDefaults.phone,
      secondPhone: src.secondPhone ?? this.formDefaults.secondPhone,
      permissionToCall: src.permissionToCall ?? this.formDefaults.permissionToCall,
      // dob: src.dob ?? this.formDefaults.dob,
      city: src.city ?? this.formDefaults.city,
      state: src.state ?? this.formDefaults.state,
      zip: src.zip ?? this.formDefaults.zip,
    });

    if (this.fullData?.preQual) {
      ['firstName', 'lastName', 'address', 'city', 'state', 'zip'].forEach(field => {
        this.infoForm.get(field)?.disable({ emitEvent: false });
      });
    } else {
      ['firstName', 'lastName', 'address', 'city', 'state', 'zip'].forEach(field => {
        this.infoForm.get(field)?.enable({ emitEvent: false });
      });
    }

  }

  applyPhoneValidator() {
    const phoneCtrl = this.infoForm.get('phone');
    if (phoneCtrl && this.currentUser?.phone) {
      phoneCtrl.setValidators([Validators.required, disallowSelfPhone(this.currentUser.phone)]);
      phoneCtrl.updateValueAndValidity();
    }
  }


  submitForm() {
    if(this.fullData.customerId) {
      if(this.fullData.address != this.infoForm.get('address')?.value 
        || this.fullData.city != this.infoForm.get('city')?.value 
        || this.fullData.state != this.infoForm.get('state')?.value 
        || this.fullData.zip != this.infoForm.get('zip')?.value) {
          this.scrubAddress();
        }else {
          this.updateCustomer(null)
        }
    }else {
      this.scrubAddress()
    }
  }

  scrubAddress() {
    const rawValues = this.infoForm.getRawValue();
    if (rawValues.dob) {
      rawValues.dobStr = formatDate(rawValues.dob, 'MM/dd/yyyy', 'en-US');
    }

    let obj = {
      user_id: this.currentUser?.id,
      user_crm_id: this.currentUser?.crm_id,
      company_id: this.currentUser?.company_id,
      distributor_id: null,
      first_name: rawValues.firstName,
      last_name: rawValues.lastName,
      address_line_1: rawValues.address,
      address_city: rawValues.city,
      address_state: rawValues.state,
      address_zip: rawValues.zip,
      phone_number: rawValues.phone,
      date_of_birth: rawValues.dobStr,
      origination: 'dish-flow'
    };

    if(this.fullData.preQual) {
      this.authenticateCustomer(obj)
    }else {
      this.loadingId = this.message.loading('Checking if address is valid...', { nzDuration: 0 }).messageId;
      this.btnLoading = true;
      this.data.postDataNoBodyDotBody(obj, 'dish/scrubAddress').subscribe((r: any) => {
        if (r.result == 'success') {
          if(this.fullData.customerId) {
            this.message.remove(this.loadingId)
            this.updateCustomer(r.data);
          }else {
            this.message.remove(this.loadingId)
            this.createCustomer(obj, r.data);
          }
        } else {
          this.message.remove(this.loadingId);
          this.btnLoading = false;
          alert(r.message?.message || r.message);
          console.log('is this [obj obj]? ', r)
        }
      }, e => {
        console.log('e here');
        console.log(e);
        alert('Error not able to verify address');
        this.btnLoading = false;
        this.message.remove(this.loadingId)
      })
    }
  }

  authenticateCustomer(o: any) {
    this.loadingId = this.message.loading('Creating customer...', { nzDuration: 0 }).messageId;
    if(this.fullData.preQual) {
      
      const obj = {
        first_name: o?.first_name,
        last_name: o?.last_name,
        phone_number: o?.phone_number,
        address_line_1: o?.address_line_1,
        address_city: o?.address_city,
        address_state: o?.address_state,
        address_zip: o?.address_zip,
        conversationId: {data: {getConversationIdResult: this.fullData.conversationId}}
      }
  
      this.data.postDataNoBodyDotBody(obj, 'dish/authenticateCustomer')
        .subscribe({
          next: (res: any) => {
            // console.log('authCust res: ', res);
            if(this.fullData.customerId) {
              this.loadingId = this.message.loading('Updating customer info...', { nzDuration: 0 }).messageId;
              this.updateCustomer({});
            }else {
              this.loadingId = this.message.loading('Creating customer...', { nzDuration: 0 }).messageId;
              this.createCustomer(obj, {});
            }
          }
        })
    }

  }

  createCustomer(obj: any, scrubRes: any) {
    const formValues = { ...this.infoForm.getRawValue() };
    this.data.postDataNoBodyDotBody(obj, 'customers/create').subscribe(
      (r: any) => {
        // console.log('Customer create response', r);
        if (r.result === 'success') {
          this.customerId = r.data.id;

          this.fullData.customerInfo = formValues;

          this.customerCreated.emit({
            customerInfo: formValues,
            customerId: this.customerId,
            scrubAddressResponse: scrubRes.scrubAddressResponse || {},
            authenticateCustomerResponse: scrubRes.authenticateCustomerResponse || {},
            conversationId: scrubRes.conversationId || this.fullData.conversationId
          });

          this.next.emit();
          setTimeout(() => {
            this.btnLoading = false;
            this.message.remove(this.loadingId)
          }, 2500);
        } else {
          this.btnLoading = false;
          this.message.remove(this.loadingId)
          alert('Failed to create order. Please try again.');
        }
      },
      (e) => {
        console.error('Error in createLead: ', e);
        alert('Failed to create order. Please try again.');
        this.btnLoading = false;
        this.message.remove(this.loadingId)
      }
    );
  }

  updateCustomer(scrubRes: any) {
    this.message.remove(this.loadingId)
    this.loadingId = this.message.loading('Updating customer info...', { nzDuration: 0 }).messageId;
    const rawValues = this.infoForm.getRawValue();
    if (rawValues.dob) {
      rawValues.dobStr = formatDate(rawValues.dob, 'MM/dd/yyyy', 'en-US');
    }

    let obj = {
      first_name: rawValues.firstName,
      last_name: rawValues.lastName,
      address_line_1: rawValues.address,
      address_city: rawValues.city,
      address_state: rawValues.state,
      address_zip: rawValues.zip,
      phone_number: rawValues.phone,
      date_of_birth: rawValues.dobStr,
      id: this.fullData.customerId
    };
    const formValues = { ...rawValues };

    this.data.postDataNoBodyDotBody(obj, 'customers/update').subscribe(
      (r: any) => {
        if (r.result === 'success') {
          this.customerId = r.data.id;

          this.fullData.customerInfo = formValues;

          this.customerCreated.emit({
            customerInfo: formValues,
            customerId: this.fullData.customerId,
            scrubAddressResponse: scrubRes?.scrubAddressResponse || this.fullData.scrubAddressResponse,
            authenticateCustomerResponse: scrubRes?.authenticateCustomerResponse || this.fullData.authenticateCustomerResponse,
            conversationId: scrubRes?.conversationId || this.fullData.conversationId            
          });

          this.next.emit();
          setTimeout(() => {
            this.btnLoading = false;
            this.message.remove(this.loadingId)
          }, 200);
        } else {
          this.btnLoading = false;
          this.message.remove(this.loadingId)
          alert('Failed to update order. Please try again.');
        }
      },
      (e) => {
        console.error('Error in createLead: ', e);
        alert('Failed to update order. Please try again.');
        this.btnLoading = false;
        this.message.remove(this.loadingId)
      }
    );
  }


}
